import * as PropertyBucket from '../../Properties/Properties';
import * as httpService from '../../Components/HttpService/HttpService';

export function getFindingKindsDataRequested() {
    return {
        type: 'GET_FINDING_KINDS_DATA_REQUESTED'
    };
}

export function getFindingKindsDataDone(data) {
    return {
        type: 'GET_FINDING_KINDS_DATA_DONE',
        payload: data
    };
}

export function getFindingKindsDataFailed(error) {
    return {
        type: 'GET_FINDING_KINDS_DATA_FAILED',
        payload: error
    };
}

export function getFindingKindsData() {
    let url = PropertyBucket.getFindingKinds();
    return dispatch => {
        dispatch(getFindingKindsDataRequested());
        let response = httpService.getService(url, "GET");
            response.then(data => {
                dispatch(getFindingKindsDataDone(data));
            })
            .catch(error => {
                dispatch(getFindingKindsDataFailed(error));
            })
    }
}

export const GET_FINDING_KINDS_DATA_REQUESTED = 'GET_FINDING_KINDS_DATA_REQUESTED';
export const GET_FINDING_KINDS_DATA_DONE = 'GET_FINDING_KINDS_DATA_DONE';
export const GET_FINDING_KINDS_DATA_FAILED = 'GET_FINDING_KINDS_DATA_FAILED';